import React, { useState } from 'react';

import { Checkbox, FormControlLabel, IconButton } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import classnames from 'classnames';
import { noop } from 'lodash';

import { TextFieldSearch } from 'components/v2';

import { useFiltersContext, useTabContext } from '../../../context/FixedFiltersContext';
import IconAllChecked from '../../../icons/IconAllChecked';
import IconAllUnchecked from '../../../icons/IconAllUnchecked';

import { BILLING_ITEM_KEY } from '../../constants';

import styles from './FilterHeader.useStyles';

interface HeaderSectionProps extends WithStyles<typeof styles> {
  totalItems?: number;
  hideSearchField?: boolean;
  onSearch?: (value: string) => void;
}

const HeaderSection: React.FC<HeaderSectionProps> = ({
  classes,
  totalItems = 0,
  onSearch = noop,
  hideSearchField = false,
}) => {
  const { filters, selectAll } = useFiltersContext();
  const { changeTab } = useTabContext();
  const [search, setSearch] = useState('');

  const handleOnChange = (value: string) => {
    setSearch(value);
    onSearch(value);
  };

  const isAllChecked =
    (filters[BILLING_ITEM_KEY].includes('all') && filters[BILLING_ITEM_KEY].length === 1) ||
    (!filters[BILLING_ITEM_KEY].includes('all') && filters[BILLING_ITEM_KEY].length === totalItems);

  return (
    <div className={classes.headerWrapper}>
      <FormControlLabel
        className={classnames({ [classes.hidden]: !!search })}
        control={
          <Checkbox
            disabled={!!search}
            onClick={() => selectAll(BILLING_ITEM_KEY)}
            icon={<IconAllUnchecked fontSize="small" />}
            checkedIcon={<IconAllChecked fontSize="small" />}
            classes={{
              root: classes.selectAllCheckbox,
            }}
            checked={isAllChecked}
          />
        }
        label={`Select All (${totalItems})`}
      />
      {
        <div className={classes.searchWrapper}>
          {!hideSearchField && <TextFieldSearch value={search} size="small" onChange={handleOnChange} />}
          <IconButton onClick={() => changeTab({ tab: null, index: false })}>
            <ExpandLessIcon />
          </IconButton>
        </div>
      }
    </div>
  );
};

export default withStyles(styles)(HeaderSection);
